'use client'
import {
	Container,
	Button,
	NewsletterForm,
	FooterList,
	SmallText,
	CookiePreferenceButton,
} from '@local/ui/components'
import Link from 'next/link'
import Image from 'next/image'

import {cx} from '@local/utils/cx'
import {usePathname} from 'next/navigation'

import XOLogo from '@local/assets/images/xo.png'
import LogoFooter from '@local/assets/svgs/logo-footer.svg'

export const FooterContent = ({data, translations}) => {
	const {
		newsletter,
		disclaimer,
		chapterLinks,
		socialClubLinks,
		socialLinks,
		email,
		telephone,
		policyLinks,
	} = data
	const pathname = usePathname()
	const isLandingPage = pathname.includes('landing/')
	if (isLandingPage) {
		return (
			<>
				<Button
					className='block w-fit mx-auto py-40'
					label='Homepage Link'
					href={pathname}>
					<LogoFooter
						className='block w-full opacity-100 h-80'
						alt='presentation' />
				</Button>
				<Container className=' border-grey-1/30'>
					<div className='flex gap-20 justify-between pb-20 font-medium uppercase span-w-12 lg:w-full text-grey-1 text-9'>
						<p className='lg:flex-1 tracking-widest'>
							{disclaimer.replace('{year}', new Date().getFullYear())}
						</p>
						<CookiePreferenceButton />

						{!!policyLinks?.length &&
							policyLinks.map((link, index) => (
								<Button
									variant='underlined'
									className='tracking-widest text-9'
									linkInput={link}
									key={`policy-${index}`}>
									{link.label}
								</Button>
							))}
					</div>
				</Container>
			</>
		)
	}
	return (
		<>
			<Button
				className='block w-fit mx-auto py-40'
				label='Homepage Link'
				href='/'>
				<LogoFooter
					className='block w-full opacity-100 h-80'
					alt='presentation' />
			</Button>
			<Container className='border-t border-grey-1/30'>
				<div
					className={cx('grid grid-cols-1 pt-50', 'lg:grid-cols-2 lg:pt-10')}>
					<NewsletterForm
						listID={newsletter.listID}
						title={newsletter.title}
						terms={newsletter.terms}
						successMessage={newsletter.successMessage}
						className='span-w-12 lg:w-full lg:border-r border-grey-1/30 lg:pt-40 lg:pb-120' />

					<ul
						className={cx(
							'flex flex-row flex-wrap lg-max:gutter-gap-x-1 gap-y-50 lg-max:py-50',
							'w-full lg:span-pl-1 lg:justify-start lg:pt-40 lg:items-start lg:gap-y-60 lg:self-start lg:pb-120',
						)}>
						<FooterList
							title={translations.get('Chapters')}
							links={chapterLinks}
							className='lg-max:span-w-6 lg:span-w-2-wide' />
						<FooterList
							title={translations.get('Transformational Travel Experiences')}
							links={socialClubLinks}
							className='lg-max:span-w-6 lg:span-w-2-wide' />
						<FooterList
							title={translations.get('Socials')}
							links={socialLinks}
							className='lg-max:span-w-6 lg:span-min-w-1-wide' />
						<FooterList
							title={translations.get('Contacts')}
							links={telephone ? [email, telephone] : [email]}
							className='lg-max:span-w-6 lg:hidden' />
						<li className='lg-max:hidden lg:span-w-2-wide'>
							<SmallText textColor='grey-1' className='pb-16'>
								{translations.get('Email')}
							</SmallText>
							<Button
								className='text-14 normal-case font-[350] tracking-normal'
								variant='underlined'
								linkInput={email}>
								{email.label}
							</Button>
						</li>
						{telephone && (
							<li className='lg-max:hidden lg:span-w-2-wide'>
								<SmallText textColor='grey-1' className='pb-16'>
									{translations.get('Telephone')}
								</SmallText>
								<Button
									className='text-14 normal-case font-[350] tracking-normal'
									variant='underlined'
									linkInput={telephone}>
									{telephone?.label}
								</Button>
							</li>
						)}
					</ul>
				</div>

				<div className='flex gap-20 justify-between flex-wrap-reverse items-center pb-20 font-medium uppercase span-w-12 lg:w-full text-grey-1 text-9'>
					<div className='flex-1 flex flex-row gap-20 items-center lg-max:justify-between'>
						<Link
							href='https://www.xoprivate.com'
							target='_blank'
							rel='noreferrer'>
							<Image src={XOLogo} alt='XO Logo' height={70} />
						</Link>
						<p className=' tracking-widest'>
							{disclaimer.replace('{year}', new Date().getFullYear())}
						</p>
					</div>
					<div className='flex flex-row gap-20 items-center'>
						<CookiePreferenceButton />

						{!!policyLinks?.length &&
							policyLinks.map((link, index) => (
								<Button
									variant='underlined'
									className='tracking-widest text-9'
									linkInput={link}
									key={`policy-${index}`}>
									{link.label}
								</Button>
							))}
					</div>
				</div>
			</Container>
		</>
	)
}
